import { Pipe, inject, PipeTransform } from "@angular/core";
import { AsPipeBase } from "../bases/as-pipe-base";
import { AppDefinitions } from "../app-definitions.service";

@Pipe({
    name: "asAc3",
    standalone: false
})
export class AsAc3Pipe extends AsPipeBase implements PipeTransform {
    constructor() {
        const _appDefinitions = inject(AppDefinitions);

        super(_appDefinitions, "ac3");
    }
}
